import { Tab, Tabs } from "@mui/material";
import { useTabs } from "hooks/useTabs";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { OverviewAnalitycs } from "./OverviewAnalitycs";
import { TabPanel } from "./TabPanel";
import { LocationAnalitycs } from "./LocationAnalytics";

export const RecipientAnalytics = () => {
    const { currentTab, handleChangeTab } = useTabs({
        key: "Analytics",
      });
    
  return (
    <CommonOutletTemplate title="Analytics">
      <div className="flex-1 flex flex-col justify-between items-stretch mt-0 pt-0">
        <Tabs
          value={currentTab}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="Overview" />
          <Tab label="By Locations" />
        </Tabs>
        <TabPanel value={currentTab} index={0}>
          <OverviewAnalitycs />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <LocationAnalitycs />
        </TabPanel>
      </div>
    </CommonOutletTemplate>
  );
};
